import { useRef } from "react"
import { Flex } from "@chakra-ui/react"
import Header from "./components/header/Hero"
import UnderHeader from "./components/underHeader/UnderHeader"
import Pricing from "./components/pricing/Pricing"
import ProductInfo from "./components/productInfo/ProductInfo"
import InsuranceTypes from "./components/insuranceTypes/InsuranceTypes"
import FAQ from "./components/faq/FAQ"
import Footer from "./components/footer/Footer"

const App = () => {
  const pricingRef = useRef()

  const handlePlansClick = () => {
    pricingRef.current.scrollIntoView({ behavior: "smooth" })
  }

  return (
    <div>
      <Header onPlansClick={handlePlansClick} />
      <Flex
        flexDirection="column"
        alignItems="center"
        paddingLeft="10vw"
        paddingRight="10vw"
      >
        <UnderHeader />
        <Pricing scrollRef={pricingRef} />
        <ProductInfo />
        <InsuranceTypes />
        <FAQ />
      </Flex>
      <Footer />
    </div>
  )
}

export default App
